import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

@Component({
  selector: 'core-table',
  templateUrl: './table.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class TableComponent {
  @Input() columns!: { label: string; key: string }[];
  @Input() hasCreateButton: boolean = false;
  @Output() toggleSelectAllEvent = new EventEmitter<void>();
  @Output() createButtonEvent = new EventEmitter<void>();

  toggleSelectAll() {
    this.toggleSelectAllEvent.emit();
  }

  openCreateModal() {
    this.createButtonEvent.emit();
  }
}
